module.exports = "<p>print-score-card works!</p>\n"